module.exports = __webpack_public_path__ + "img/75.70780469.jpg";